import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeSelector } from "./themes/ThemeSelector";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <ThemeSelector>
            <App />
        </ThemeSelector>
    </React.StrictMode>
);
reportWebVitals();
